const { DEVICE_FEATURE_CATEGORIES, DEVICE_FEATURE_TYPES } = require('../../../utils/constants');

const ENERGY_INDEX_FEATURE_TYPES = {
  [DEVICE_FEATURE_CATEGORIES.ENERGY_SENSOR]: [
    DEVICE_FEATURE_TYPES.ENERGY_SENSOR.INDEX,
    DEVICE_FEATURE_TYPES.ENERGY_SENSOR.ENERGY,
  ],
  [DEVICE_FEATURE_CATEGORIES.SWITCH]: [DEVICE_FEATURE_TYPES.SWITCH.ENERGY],
  [DEVICE_FEATURE_CATEGORIES.TELEINFORMATION]: [
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EAST,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF01,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF02,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF03,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF04,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF05,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF06,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF07,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF08,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF09,
    DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF10,
  ],
};

module.exports = {
  ENERGY_INDEX_FEATURE_TYPES,
};
